import React from "react";
import cn from "classnames";
import styles from "./Button.module.scss";

type ButtonType = "button" | "submit" | "reset";
type ButtonVariant = "primary" | "secondary" | "pale";
type ButtonSize = "default" | "tiny" | "small" | "medium";
export type ButtonOwnProps = {
  type?: ButtonType;
  variant?: ButtonVariant;
  size?: ButtonSize;
  disabled?: boolean;
};

export type ButtonProps = Omit<React.HTMLProps<HTMLButtonElement>, "size"> & ButtonOwnProps;

export const Button = React.forwardRef<HTMLButtonElement, ButtonProps>((props, ref) => {
  const { type = "button", size = "default", className, variant, children, ...restComponentProps } = props;
  const classes = cn(styles["button"], styles[`variant-${variant}`], styles[`size-${size}`], className);

  return (
    <button ref={ref} type={type} className={classes} {...restComponentProps}>
      {children}
    </button>
  );
});

Button.displayName = Button.name;
